import {
  TimeFormats,
  addDays,
  createState,
  defaultDateRange,
  endOfDay,
  formatDate,
  parseDate,
  startOfDay,
  subDays,
} from "@theprelude/core";
import { ChevronIcon, IconButton } from "@theprelude/ds";

export const useDateRange = createState<{
  start: string;
  finish: string;
}>({
  start: defaultDateRange.start.toISOString(),
  finish: defaultDateRange.finish.toISOString(),
});

const DateSlider = () => {
  const query = useDateRange((state) => state.value);
  const mutate = useDateRange((state) => state.setValue);

  function nextDateRange() {
    const start = startOfDay(parseDate(query.finish));
    const finish = addDays(endOfDay(parseDate(query.finish)), 29);

    return mutate({
      start: start.toISOString(),
      finish: finish.toISOString(),
    });
  }

  function previousDateRange() {
    const start = subDays(startOfDay(parseDate(query.start)), 29);
    const finish = startOfDay(parseDate(query.start));
    return mutate({
      start: start.toISOString(),
      finish: finish.toISOString(),
    });
  }

  const formattedStart = formatDate(
    parseDate(query.start),
    TimeFormats.DATE_MEDIUM,
  );
  const formattedFinish = formatDate(
    parseDate(query.finish),
    TimeFormats.DATE_MEDIUM,
  );

  const disableNext = endOfDay(parseDate(query.finish)) >= endOfDay(new Date());

  return (
    <div className="flex w-max items-center gap-2 rounded-xl border border-stroke-line bg-primary-background px-2 py-1">
      <IconButton
        icon={<ChevronIcon className="rotate-[270deg]" />}
        onClick={previousDateRange}
      />
      <span className="whitespace-nowrap text-xs">{`${formattedStart} - ${formattedFinish}`}</span>
      <IconButton
        disabled={disableNext}
        icon={<ChevronIcon className="rotate-[90deg]" />}
        onClick={nextDateRange}
      />
    </div>
  );
};

export default DateSlider;
